<template>
    <div class="gh-page gh-page-summit" sticky-container>
        <gh-header/>
        <div class="gh-section">
            <div class="container">
                <p class="gh-heading">Thank you for upgrading, {{name}}.</p>
                <p class="gh-subheading">Please download your tax invoice by clicking button below.</p>
                <div class="gh-actions">
                    <a class="gh-button gh-button-redesign--cta" href="/suicideprevention/invoice" target="_blank">Download Invoice</a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import ghHeader from '@/modules/events/suicidePreventionSummit/components/UpgradeHeader'

    export default {
        components: {
            ghHeader
        },

        computed: {
           name () {
             return (new URLSearchParams(location.search)).get('name')
           }
        },

        methods: {
            popUpMsg() {
                this.$alert(
                    "The Event Portal for the 2022 Suicide Prevention Summit will be accessible for registered attendees from Monday, April 18. Keep an eye on your emails for further instructions.",
                    "Hold tight... we'll be ready soon",
                    {
                    confirmButtonText: "OK",
                    }
                );
            },

            eventPortalLink(year) {
                return `https://events.mentalhealthacademy.co.uk/suicideprevention/${year}/verify`;
            }
        }
    }
</script>

<style lang="scss" src="~/sass/pages/landing/summit.scss">
  @import url('https://fonts.googleapis.com/css?family=Catamaran');
</style>

<style lang="scss" scoped>
    .gh-section {
        display: flex;
        justify-content: center;
        align-items: center;
        min-height: 50vh;
        text-align: center;
    }

    .gh-subheading {
        font-weight: 400;
    }

    .gh-header {
        box-shadow: none !important;
    }

    .gh-actions {
        margin-top: 2rem;
    }
</style>
